import React from 'react';
import { Lightbulb, BookOpen, AlertCircle } from 'lucide-react';
interface RuleCardProps {
  title: string;
  content: string;
  icon?: 'lightbulb' | 'book' | 'alert';
}
export function RuleCard({
  title,
  content,
  icon = 'lightbulb'
}: RuleCardProps) {
  const Icon = icon === 'lightbulb' ? Lightbulb : icon === 'book' ? BookOpen : AlertCircle;
  return <div className="bg-amber-50 p-4 rounded-xl border border-amber-100" data-id="element-5702">
      <div className="flex items-start gap-3" data-id="element-5703">
        <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0" data-id="element-5704">
          <Icon className="w-5 h-5 text-amber-700" data-id="element-5705" />
        </div>
        <div className="flex-1" data-id="element-5706">
          <h4 className="font-bold text-amber-900 mb-2" data-id="element-5707">{title}</h4>
          <p className="text-slate-700 text-sm leading-relaxed" data-id="element-5708">{content}</p>
        </div>
      </div>
    </div>;
}